import { render, staticRenderFns } from "./AuthPopup.vue?vue&type=template&id=221e3490&scoped=true"
import script from "./AuthPopup.vue?vue&type=script&lang=js"
export * from "./AuthPopup.vue?vue&type=script&lang=js"
import style0 from "./AuthPopup.vue?vue&type=style&index=0&id=221e3490&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221e3490",
  null
  
)

export default component.exports